import ManageProperties from './manageProperties';

export default ManageProperties;
